import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'semantic-ui-react';
import UserInfo from '_views/userInfo';

const NoEndUser = props => (
  <div>
    Unclaimed
  </div>
);

const ACLicenseActivationInfo = ({
  license,
  onNavigateToUser
}) => {
  return (
    <Grid>
      <Grid.Row columns={ 2 } >
        <Grid.Column width={ 8 } >
          <div>
            <b>End User:</b>
          </div>
          <div>
            <UserInfo
              onClick={ () => onNavigateToUser(license.user) }
              user={ license.user }
              whenNull={<NoEndUser />}
            />
          </div>
        </Grid.Column>
        <Grid.Column width={ 8 } >
          <div>
            <b>Created by:</b>
          </div>
          <UserInfo
            onClick={ () => onNavigateToUser(license.activated_by) }
            user={ license.activated_by }
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

ACLicenseActivationInfo.propTypes = {
  license: PropTypes.shape({
    activated_by: PropTypes.shape({
      _id: PropTypes.string.isRequired
    }).isRequired,
    user: PropTypes.shape({
      _id: PropTypes.string.isRequired
    })
  }).isRequired,
  onNavigateToUser: PropTypes.func.isRequired
}

export default ACLicenseActivationInfo;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/activationInfo.js